import React, {useEffect, useState} from "react";
import Slider from "react-slick";
import PreSelectedParlayCard from "../../components/PreSelectedContestCard/PreSelectedParlayCard";
import {useGetPreSelectedParlaysLobbyDataQuery} from "../../stores/pickX/pickX.api";
import moment from "moment";
import {PayoutModel, PreSelectedParlayStatus} from "../../constants/PickXEnums";

const arrowStyles = {
    position: 'absolute',
    background: "#172630",
    color: "#fff",
    border: "thin solid #35444F",
    borderRadius: "100%",
    cursor: "pointer",
    zIndex: 1,
    width: "20px",
    height: "20px",
}

function nextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            role={"navigation"}
            className={className}
            style={{ ...style, display: "block", ...arrowStyles }}
            onClick={onClick}
        ><i className={`fa-solid fa-angle-right`}/></div>
    );
}

function prevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            role={"navigation"}
            className={className}
            style={{ ...style, display: "block", ...arrowStyles }}
            onClick={onClick}
        ><i className={`fa-solid fa-angle-left`}/></div>
    );
}

const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 2000,
    slidesToShow: 5,
    slidesToScroll: 4,
    autoplay: false,
    arrows: false,
    // nextArrow: <nextArrow/>,
    // prevArrow: <prevArrow/>,
    responsive: [
        {
            breakpoint: 1600,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            }
        },
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

import "./PreSelectedParlaysBanners.style.scss";
export const PreSelectedParlaysBanners = (props) => {

    const { data: lobbyPreSelectedParlaysData } = useGetPreSelectedParlaysLobbyDataQuery({});
    const [showAllPreSelectedParlays, setShowAllPreSelectedParlays] = useState(false);

    const preSelectedParlaysViewData = {
        preSelectedParlays : lobbyPreSelectedParlaysData?.PreSelectedParlays ?? [],
        games: lobbyPreSelectedParlaysData?.Games ?? []
    };

    useEffect(() => {
        props.setPreSelectedParlayBannersExists(preSelectedParlaysViewData.preSelectedParlays.length > 0);
    }, [preSelectedParlaysViewData.preSelectedParlays]);

    const now = moment();
    preSelectedParlaysViewData.preSelectedParlays =
        preSelectedParlaysViewData.preSelectedParlays?.filter(parlay => {
            const parlayDateStart = moment(parlay.DateStart);
            const fiveHoursAfterStart = moment(parlay.DateStart).add(5, 'hours');
            return (
                parlay.Status === PreSelectedParlayStatus.Active ||
                parlayDateStart.isAfter(now) ||  // Not yet started
                now.isBefore(fiveHoursAfterStart) // Started but within 5 hours
            );
        }).sort( (p1, p2)=>new Date(p1.DateStart).getTime()-new Date(p2.DateStart).getTime());

    const featuredParlays = preSelectedParlaysViewData.preSelectedParlays;//.filter(p => p.PayoutModel === PayoutModel.Pick12 || p.PayoutModel === PayoutModel.Pick16);
    const otherParlays = [];//preSelectedParlaysViewData.preSelectedParlays.filter(p => p.PayoutModel !== PayoutModel.Pick12 && p.PayoutModel !== PayoutModel.Pick16);

    /* UnComment to test other parlays view
    console.log(featuredParlays.length);
    if(featuredParlays.length > 0)
    for(var i =0; i < 10; i++)
    otherParlays.push(featuredParlays[0]);
    */



    const toggleAllPreSelectedParlays = () => {
        setShowAllPreSelectedParlays(!showAllPreSelectedParlays);
    }


    return <div className={"PreSelectedParlaysBanners"}>
            <div className="toggleBar">
                <a onClick={()=>toggleAllPreSelectedParlays()}
                   className={showAllPreSelectedParlays? "up" : "down"}>
                    <i className={`fa-solid fa-angle-right`}/>
                </a>
            </div>
            <Slider className={`PreSelectedParlaysBannersSlider ${props.isOpen? "open" : "close"}`}
                    {...sliderSettings}>
                { featuredParlays &&
                  featuredParlays?.map((parlay, i) =>
                    <PreSelectedParlayCard asBanner={true}
                                           key={i+parlay.Id}
                                           parlay={parlay} />)}
            </Slider>
        {/* note: for now we don't show 2 sections */}
        {/*otherParlays.length > 0 &&
            <div className="other-preSelectedBanners">
                <div className={`toggleBar ${showAllPreSelectedParlays ? "open" : "close"}`}>
                    <a href="#"
                       onClick={()=>toggleAllPreSelectedParlays()}
                       className={showAllPreSelectedParlays? "up" : "down"}>
                        {showAllPreSelectedParlays ? "Show Less" : "View All"} <i className={`fa-solid fa-angle-down`}/>
                    </a>
                </div>
                <div className={`cards ${showAllPreSelectedParlays ? "open" : "close"}`}>
                { otherParlays &&
                    otherParlays?.map((parlay, i) =>
                    <PreSelectedParlayCard asBanner={true}
                                           key={i+parlay.Id}
                                           parlay={parlay} />)}
                </div>
            </div>*/}
    </div>
}

export default PreSelectedParlaysBanners;